// fr strings for messages/auth.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const auth: Dict = {
  "auth.continueGoogle": "Continuer avec Google",
  "auth.orEmail": "ou par e-mail",
  "auth.email": "E-mail",
  "auth.emailInput": "Adresse e-mail",
  "auth.emailPlaceholder": "toi@exemple.com",
  "auth.password": "Mot de passe",
  "auth.passwordInput": "Mot de passe",
  "auth.passwordPlaceholderNew": "6 caractères minimum",
  "auth.signUp": "S'inscrire",
  "auth.logIn": "Se connecter",
  "auth.signIn": "Se connecter",
  "auth.createAccount": "Créer un compte",
  "auth.createYourAccount": "Crée ton compte",
  "auth.forgotPassword": "Mot de passe oublié ?",
  "auth.agree": "J'accepte les",
  "auth.agreeJammable": "J'accepte les",
  "auth.and": "et la",
  "auth.terms": "Conditions d'utilisation",
  "auth.privacy": "Politique de confidentialité",
  "auth.agreeRequired":
    "Accepte nos Conditions d'utilisation et notre Politique de confidentialité.",
  "auth.welcomeBack": "Content de te revoir !",
  "auth.welcomeNew": "Bienvenue sur Jammable !",
  "auth.registerError":
    "Une erreur est survenue lors de l'inscription. Réessaie.",
  "auth.backToLogin": "Retour à la connexion",
  "auth.invalidEmail": "E-mail invalide",
  "auth.emailRequired": "Saisis ton e-mail",
  "auth.passwordMin": "Le mot de passe doit contenir au moins 6 caractères",
  "auth.passwordRequired": "Saisis ton mot de passe",

  "auth.modal.signInTitle": "Connecte-toi à Jammable",
  "auth.modal.subtitle": "Fais des covers IA avec plus de 100 000 voix.",
  "auth.modal.signUpButton": "Créer un compte",
  "auth.modal.signInButton": "Se connecter",
  "auth.modal.haveAccount": "Déjà un compte ?",
  "auth.modal.newHere": "Nouveau ici ?",
  "auth.modal.createAnAccount": "Crée un compte",

  "auth.login.heading": "Content de te revoir",
  "auth.login.blurb":
    "Tes covers, tes voix et tes collections t'attendent là où tu les as laissées.",
  "auth.login.noAccount": "Pas encore de compte ?",
  "auth.signup.heading": "Fais chanter n'importe quelle voix sur",
  "auth.signup.headingHighlight": "ton audio",
  "auth.signup.blurb":
    "Plus de 100 000 voix, toutes tes covers au même endroit et un studio pour les duos et les vidéos.",
  "auth.signup.haveAccount": "Tu as déjà un compte ?",

  "auth.forgot.title": "Réinitialise ton mot de passe",
  "auth.forgot.blurb":
    "Saisis ton e-mail et on t'envoie un lien pour en choisir un nouveau.",
  "auth.forgot.send": "Envoyer le lien",
  "auth.forgot.sentToast": "E-mail de réinitialisation envoyé !",
  "auth.forgot.sent":
    "C'est envoyé. Vérifie ta boîte de réception et tes spams.",
  "auth.forgot.google": "Inscrit avec Google ?",
  "auth.forgot.googleAfter": "à la place",

  "auth.reset.title": "Choisis un nouveau mot de passe",
  "auth.reset.blurb":
    "Au moins 6 caractères. Tu t'en serviras pour te connecter.",
  "auth.reset.newPassword": "Nouveau mot de passe",
  "auth.reset.submit": "Réinitialiser le mot de passe",
  "auth.reset.success": "Mot de passe réinitialisé !",
  "auth.reset.expired": "Le lien a expiré ?",
  "auth.reset.sendNew": "Demande un nouveau lien",

  "auth.error.google.popup-closed-by-user":
    "La fenêtre a été fermée avant la fin de la connexion. Réessaie.",
  "auth.error.google.popup-blocked":
    "Ton navigateur a bloqué la fenêtre pop-up. Autorise les pop-ups et réessaie.",
  "auth.error.google.operation-not-supported-in-this-environment":
    "Cette méthode de connexion ne fonctionne pas dans ton navigateur actuel.",
  "auth.error.google.network-request-failed":
    "Erreur réseau. Vérifie ta connexion internet et réessaie.",
  "auth.error.google.cancelled-popup-request":
    "Plusieurs tentatives de connexion ont été détectées. Réessaie.",
  "auth.error.google.timeout":
    "La connexion a pris trop de temps. Vérifie ta connexion internet et réessaie.",
  "auth.error.google.account-exists-with-different-credential":
    "Un compte existe déjà avec cette adresse e-mail. Connecte-toi avec la méthode utilisée à l'inscription.",
  "auth.error.google.invalid-credential":
    "Les identifiants sont invalides ou ont expiré. Réessaie.",
  "auth.error.google.user-disabled":
    "Ton compte a été désactivé. Contacte le support pour obtenir de l'aide.",
  "auth.error.google.user-not-found":
    "Aucun compte n'est associé à cette adresse e-mail. Réessaie ou crée un compte.",
  "auth.error.google.wrong-password":
    "Le mot de passe est incorrect. Réessaie.",

  "auth.error.signIn.invalid-email":
    "L'adresse e-mail saisie n'est pas valide. Vérifie-la et réessaie.",
  "auth.error.signIn.user-disabled":
    "Ton compte a été désactivé. Contacte le support pour obtenir de l'aide.",
  "auth.error.signIn.user-not-found":
    "Aucun compte n'est associé à cette adresse e-mail. Réessaie ou crée un compte.",
  "auth.error.signIn.wrong-password":
    "Le mot de passe saisi est incorrect. Réessaie.",
  "auth.error.signIn.too-many-requests":
    "Trop de tentatives de connexion échouées. Réessaie plus tard.",

  "auth.error.signUp.email-already-in-use":
    "Cette adresse e-mail est déjà utilisée par un autre compte. Utilise une autre adresse.",
  "auth.error.signUp.invalid-email":
    "L'adresse e-mail saisie n'est pas valide. Vérifie-la et réessaie.",
  "auth.error.signUp.operation-not-allowed":
    "La création de comptes est momentanément désactivée. Réessaie plus tard.",
  "auth.error.signUp.weak-password":
    "Le mot de passe doit contenir au moins 6 caractères. Choisis un mot de passe plus sûr.",

  "auth.error.forgot.invalid-email": "Saisis une adresse e-mail valide.",
  "auth.error.forgot.user-not-found":
    "Aucun compte n'est associé à cette adresse e-mail.",
  "auth.error.forgot.missing-android-pkg-name":
    "Un nom de package Android est requis.",
  "auth.error.forgot.missing-continue-uri":
    "Une URL de redirection est requise.",
  "auth.error.forgot.missing-ios-bundle-id": "Un Bundle ID iOS est requis.",
  "auth.error.forgot.unauthorized-continue-uri":
    "L'URL de redirection fournie n'est pas autorisée.",
  "auth.error.forgot.operation-not-allowed":
    "La réinitialisation du mot de passe n'est pas disponible.",

  "auth.error.reset.invalid-action-code":
    "Le lien n'est pas valide. Vérifie-le et réessaie.",
  "auth.error.reset.expired-action-code":
    "Le lien a expiré. Demande un nouvel e-mail de réinitialisation.",
  "auth.error.reset.user-disabled":
    "Ce compte a été désactivé. Contacte le support.",
  "auth.error.reset.user-not-found":
    "Aucun compte n'est associé à cette adresse e-mail.",
  "auth.error.reset.weak-password":
    "Le mot de passe doit contenir au moins 6 caractères.",
  "auth.error.reset.operation-not-allowed":
    "La réinitialisation du mot de passe n'est pas disponible.",

  "auth.seo.loginTitle": "Connexion - Jammable",
  "auth.seo.loginDescription": "Connecte-toi à ton compte Jammable.",
  "auth.seo.signupTitle": "Inscription | Jammable",
};

export default auth;
